import React from "react";
import { ViewContext } from "./ViewContext";
import { SignUpView } from "../Components/Views/SignUpView";

export function ViewContextProvider(props: any) {
	const [currentView, setCurrentView] = React.useState<() => JSX.Element>(SignUpView);
	let value = { currentView, setCurrentView };
	return <ViewContext.Provider value={value}>{props.children}</ViewContext.Provider>;
}
